// The doc catalogue in force, re-rendering its screen when the backend's list changes it.
//
// The doc templates list says whether the backend serves Technical Crawl (ourteam-backend#6394).
// One read per page load fills that in; until it lands, the catalogue is the one from before it.
import { useEffect, useSyncExternalStore } from "react";
import { activeDocExpected, subscribeDocExpected, type DocExpectation } from "@service/aeo/clientDocsRules";
import { getDocTemplates } from "@service/aeo/clientDocsWrite";

let asked = false;

function askOnce(): void {
    if (asked) return;
    asked = true;
    // A failed read is asked again on the next mount: the catalogue stays the one before it meanwhile.
    getDocTemplates().then((r) => {
        if (!r.ok) asked = false;
    }, () => {
        asked = false;
    });
}

/** The active catalogue. A component that shows or labels doc types reads it through this hook. */
export function useDocCatalogue(): readonly DocExpectation[] {
    useEffect(() => {
        askOnce();
    }, []);
    return useSyncExternalStore(subscribeDocExpected, activeDocExpected, activeDocExpected);
}
